/***
 * return{
  section{
    QuestionsetCd_1:{
      Dataelementcd_1:{
        question:'',
        answer:''
      },
      Dataelementcd_2:{
        question:'',
        answer:''
      }
    },
    QuestionsetCd_2:{
      Dataelementcd_1:{
        question:'',
        answer:''
      },
      Dataelementcd_2:{
        question:'',
        answer:''
      }
    }
  }
 }
 */
export const LIFE_STYLE_PERSONAL_DETAILS = () => {
  return {
    LIFE_STYLE_PERSONAL_DETAILS: {//section
      TRAVEL: {//QuestionsetCd
        YESNODATAELEMENT1: {//Dataelementcd
          question: 'Do you plan to live or travel outside India for more than 30 days?',
          answer: ''
        },
        FREETEXT1: {//Dataelementcd
          question: 'Please give details:',
          answer: ''
        }
      },
      SUBSTANCEABUSE: {
        YESNODATAELEMENT2: {
          question: 'Do you consume Tobacco/Alcohol/Any Narcotics or have you consumed it in the past?',
          answer: ''
        }
      },
      DRUGS: {
        YESNODATAELEMENT1: {
          question: 'Have you in the past used or do you use any habit forming drugs or narcotics or received any drug abstinence treatment?',
          answer: ''
        },
        FREETEXT1: {
          question: 'Please give details: ',
          answer: ''
        }
      },
      ALCOHOL: {
        YESNODATAELEMENT1: {
          question: 'Do you consume alcohol?',
          answer: ''
        }
      },
      ALCOHOLCOUNT: {
        INTEGERELEMENT1: {
          question: 'Specify per week consumption: Beer (Glasses)',
          answer: ''
        },
        INTEGERELEMENT2: {
          question: 'Specify per week consumption: Hard Liquor(mls)',
          answer: ''
        },
        INTEGERELEMENT3: {
          question: 'Specify per week consumption: Wine(mls)',
          answer: ''
        }
      },
      SMOKE: {
        YESNODATAELEMENT1: {
          question: 'Do you smoke or consume tobacco in any form e.g (paan, tobacco, gutka) or have done so in the past twelve months?',
          answer: ''
        }
      },
      SMOKE2: {
        INTEGERELEMENT1: {
          question: 'Specify per day consumption: Cigarette Sticks',
          answer: ''
        },
        INTEGERELEMENT2: {
          question: 'Specify per day consumption: Cigar Sticks',
          answer: ''
        },
        INTEGERELEMENT3: {
          question: 'Specify per day consumption: Bidi Sticks',
          answer: ''
        },
        INTEGERELEMENT4: {
          question: 'Specify per day consumption: Gutka Pouch',
          answer: ''
        },
        INTEGERELEMENT5: {
          question: 'Specify per day consumption: Paan',
          answer: ''
        }
      },
      HEIGHT: {
        HEIGHTELEMENT1: {
          question: 'Specify your height in',
          answer: ''
        }
      },
      HEIGHTCMS: {
        INTEGERELEMENT1: {
          question: 'Height (cms)',
          answer: ''
        }
      },
      HEIGHTFTIN: {
        INTEGERELEMENT1: {
          question: 'Height (feet)',
          answer: ''
        },
        INTEGERELEMENT2: {
          question: 'Height (inches)',
          answer: ''
        }
      },
      WEIGHT: {
        INTEGERELEMENT1: {
          question: 'Weight (in kgs)',
          answer: ''
        }
      },
      WEIGHTVARIATION1: {
        YESNODATAELEMENT1: {
          question: 'Has there been any variation in weight during the past 12 months? ',
          answer: ''
        }
      },
      WEIGHTGAINLOSS: {
        GAINLOSSELEMENT1: {
          question: 'Please mention gain/loss',
          answer: ''
        },
        INTEGERELEMENT1: {
          question: 'Please mention gain/loss (in kg)',
          answer: ''
        },
        FREETEXT1: {
          question: 'Please provide reasons',
          answer: ''
        }
      }
    }
  }
}

